export const ROLE_REQUEST = "ROLE_REQUEST";
export const ROLE_SUCCESS = "ROLE_SUCCESS";
export const ROLE_FAIL = "ROLE_FAIL";

export const POST_ROLE_REQUEST = "POST_ROLE_REQUEST";
export const POST_ROLE_SUCCESS = "POST_ROLE_SUCCESS";
export const POST_ROLE_FAIL = "POST_ROLE_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
